import React from "react"
import {
  Button,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import Spinners from "components/Common/Spinner"
import { useFormik } from "formik"
import * as Yup from "yup"
import toast from "react-hot-toast"
import { useSelector } from "react-redux"
import InvoiceUpload from "pages/WealthPartnerPages/Invoices/InvoiceUpload"
import { useCreateInvoiceMutation } from "store/api/wealthpartnerapi/invoices/invoice.api"
import { formatAmount, sanitizeIntegerInput } from "helpers/common"

const defaultValues = {
  title: "",
  amount: "",
  file: "",
}

function AddInvoiceModal({ open, setOpen, refresh }) {
  const { user } = useSelector((state) => state.user)
  const toggle = () => setOpen(!open)
  const [createInvoice, { isLoading }] = useCreateInvoiceMutation()

  const onFormSubmit = async (values) => {
    try {
      const { message, success } = await createInvoice(values).unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })
        refresh()
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }

      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { ...defaultValues },
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      await onFormSubmit(values)
    },
  })

  return (
    <div>
      <Modal isOpen={open} toggle={toggle} centered>
        <ModalHeader
          toggle={() => {
            setOpen((prev) => !prev)
          }}
        >
          Create Invoice
        </ModalHeader>
        <ModalBody>
          <Container>
            <Form
              className="form-horizontal"
              onSubmit={(e) => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <Row className="mb-2">
                <Col xl={12} className="mb-2">
                  <Label className="form-label">{"Title"}</Label>
                  <Input
                    name="title"
                    className="form-control"
                    placeholder={"Enter Title"}
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.title || ""}
                    invalid={
                      validation.touched.name && validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.title && validation.errors.title ? (
                    <FormFeedback type="invalid">
                      {validation.errors.title}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12} className="mb-2">
                  <Label className="form-label">Amount</Label>
                  <Input
                    name="amount"
                    className="form-control"
                    placeholder="Enter Amount"
                    type="text"
                    onChange={(e) =>
                      sanitizeIntegerInput(
                        e,
                        validation.setFieldValue,
                        "amount"
                      )
                    }
                    value={`₹ ${formatAmount(validation.values.amount)}`}
                    invalid={
                      validation.touched.amount && validation.errors.amount
                        ? true
                        : false
                    }
                  />
                  {validation.touched.amount && validation.errors.amount ? (
                    <FormFeedback type="invalid">
                      {validation.errors.amount}
                    </FormFeedback>
                  ) : null}{" "}
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">Upload Invoice</Label>
                  <InvoiceUpload
                    fieldKey={"file"}
                    validation={validation}
                    extensionAllowedInput={".pdf"}
                    extensionAllowed={["application/pdf"]}
                    preview={true}
                  />
                </Col>
              </Row>

              <div className="mt-3 py-1 button-wrapper">
                <Button
                  type="submit"
                  color="primary"
                  className="w-100"
                  disabled={isLoading}
                >
                  {isLoading ? <Spinners /> : "Create Invoice"}
                </Button>
              </div>
            </Form>
          </Container>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default AddInvoiceModal
